import { styled, keyframes } from 'leva/plugin'

export const StyledBounce = styled('div', {
    flex: '1 1 0%',
    // marginTop: '',
    overflow:'clip',
    pointerEvents: 'none',
    position: 'relative',
})